import {
    getAsync,
    postAsync,
    putAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/PracticeType";

// Get all PracticeTypes for a discipline
export async function getPracticeTypeForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/getAllForDiscipline/${disciplineId}`);
}

// Create an PracticeType for a Discipline
export async function createPracticeTypeForDisciplineAsync(disciplineId, model) {
  return await postAsync(`${endpoint}/${disciplineId}`, model);
}

// Update an PracticeType
export async function updatePracticeTypeAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

// Delete an PracticeType
export async function deletePracticeTypeAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}